import { render, staticRenderFns } from "./detailModal.vue?vue&type=template&id=6f1ce7a2&scoped=true&"
import script from "./detailModal.vue?vue&type=script&lang=ts&"
export * from "./detailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1ce7a2",
  null
  
)

export default component.exports